/** Client-side mirror of the backend's password-strength requirements. */

export const PASSWORD_RULES = [
  { key: "length", test: (pw) => pw.length >= 8 },
  { key: "lowercase", test: (pw) => /[a-z]/.test(pw) },
  { key: "uppercase", test: (pw) => /[A-Z]/.test(pw) },
  { key: "number", test: (pw) => /[0-9]/.test(pw) },
  { key: "special", test: (pw) => /[^a-zA-Z0-9]/.test(pw) },
];

// `t` is the translation function from useTranslation() — labels live in the
// auth.passwordStrength dictionary namespace, keyed by rule.key.
export const getPasswordRuleResults = (password = "", t) =>
  PASSWORD_RULES.map((rule) => ({
    key: rule.key,
    label: t ? t(`auth.passwordStrength.${rule.key}`) : rule.key,
    passed: rule.test(password),
  }));

export const isPasswordValid = (password = "") =>
  PASSWORD_RULES.every((rule) => rule.test(password));
